module.exports = __webpack_public_path__ + "static/media/FIX NEW LOGO MEIJI WELLNESS.9139a28e.png";